import React from 'react'

const EtAdminUTMTracking = () => {
  return (
    <div>EtAdminUTMTracking</div>
  )
}

export default EtAdminUTMTracking